import styled from "styled-components";

export const LoadingPageStyled = styled.div`
  opacity: ${({ isShow }) => (isShow ? 1 : 0)};
  visibility: ${({ isShow }) => (isShow ? "visible" : "hidden")};

  transition: 0.3s;

  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;

  display: flex;
  align-items: center;
  justify-content: center;

  .loading-page__inner {
    background-color: white;
    border-radius: 10px;
    min-width: 200px;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
  }
`;
